export default {
  'totalHeaderDetails.title': 'Loan Account Details',
  'totalHeaderDetails.accountSelection': '<%= type %> Account',
  'totalHeaderDetails.gridName': 'LoanAccountDetails',
  'totalHeaderDetails.transactionsFor': 'Transactions for',

  // Column Names
  // rest of the other columns will get labels from common file
  'totalHeaderDetails.transactionDescription': 'Transaction Description',
  'totalHeaderDetails.bankRefCode': 'Bank Reference Code',
  'totalHeaderDetails.debit': 'Debit/Draw',
  'totalHeaderDetails.credit': 'Credit/Payment',
  'totalHeaderDetails.availableBalCRS': 'Current Available',

  // For Dropdown:
  'totalHeaderDetails.balancesAsOf': 'Balances as of'
};
